import { createImageUrlBuilder } from '@sanity/image-url';
import { Cloudinary } from '@cloudinary/url-gen';
import type { SanityImageObject, ImageUrlBuilder } from '@sanity/image-url';
import { ApplicationState } from '../redux/modules/application';

// Get a pre-configured url-builder from your sanity client
const motorBuilder = (applicationState: ApplicationState) =>
  createImageUrlBuilder({
    projectId: applicationState.sanityProjectId,
    dataset: applicationState.sanityMotorDataset,
  });

const nafBuilder = (applicationState: ApplicationState) =>
  createImageUrlBuilder({
    projectId: applicationState.sanityProjectId,
    dataset: applicationState.sanityNafNoDataset,
  });

// Then we like to make a simple function like this that gives the
// builder an image and returns the builder for you to specify additional
// parameters:

export interface MotorListItemImage {
  type: 'nafimage' | null;
  caption: string | null;
  asset: { reference: string | null; type: 'reference' | null };
}

export const imageUrlForMotor = (
  image: MotorListItemImage | null,
  applicationState: ApplicationState,
): ImageUrlBuilder | undefined =>
  (!!image && image.asset && image.asset.reference && motorBuilder(applicationState).image(image.asset.reference)) ||
  undefined;

export const imageUrlForNaf = (image: SanityImageObject, applicationState: ApplicationState): ImageUrlBuilder =>
  image && image.asset && nafBuilder(applicationState).image(image.asset._ref);

export const cloudinaryAttachment = (publicId: string, application: ApplicationState, filename?: string): string => {
  const cl = new Cloudinary({
    cloud: {
      cloudName: application.imageCloudName,
    },
    url: {
      secure: true,
    },
  });
  const attachment = cl.image(publicId);
  const flag = filename
    ? `attachment:${filename.replace('æ', 'ae').replace('ø', 'oe').replace('å', 'aa')}`
    : `attachment`;
  attachment.addFlag(flag);
  return attachment.toURL();
};
